<template>
  <div class="payment-types">
    <img
      loading="lazy"
      src="@/assets/payment-cards/apple-pay.svg"
      width="51"
      height="33"
      alt="Apple Pay"
    />
    <img
      loading="lazy"
      src="@/assets/payment-cards/google-pay.svg"
      width="51"
      height="33"
      alt="Google Pay"
    />
    <img
      loading="lazy"
      src="@/assets/payment-cards/visa.svg"
      width="51"
      height="33"
      alt="Visa"
    />
    <img
      loading="lazy"
      src="@/assets/payment-cards/mastercard.svg"
      width="51"
      height="33"
      alt="Mastercard"
    />
    <img
      loading="lazy"
      src="@/assets/payment-cards/paypal.svg"
      width="51"
      height="33"
      alt="PayPal"
    />
  </div>
</template>

<style scoped>
.payment-types {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.payment-types img {
  height: 2em;
  width: auto;
  margin: 1em 0.25em;
}

.payment-types img:first-of-type {
  margin-left: 1.3em;
}

.payment-types img:last-of-type {
  margin-right: 1.3em;
}
</style>
